module.exports = __webpack_public_path__ + "media/images/emblems/Staufen_blason-124a91c35ace659383d4f6e5e98612d2.svg";